// src/components/ShaTelephony/providers/awsConnectProvider.ts
import "amazon-connect-streams";

import { HubConnection } from "@microsoft/signalr";
import {
  ITelephonyProvider,
  CallDetails,
  CallStatus,
  CallDirection,
  AwsConnectConfig,
  TelephonyEvent,
  TelephonyEventType,
} from "../models";
import { TelephonyBaseProvider } from "./telephonyBaseProvider";
import axios, { AxiosResponse } from "axios";
interface AwsConnectLoginResponse {
  sessionId: string;
  success: boolean;
  message?: string;
  connectInstanceId?: string;
}

interface AwsConnectStartSessionResponse {
  success: boolean;
  isOnline: boolean;
  isAvailable: boolean;
  agentState?: string;
  routingProfileArn?: string;
  queueArns?: string[];
  message?: string;
}

// interface AwsConnectEndShiftResponse {
//   success: boolean;
//   message?: string;
// }

//const CCP_URL = 'https://pd-contactcentre.my.connect.aws/connect/ccp-v2/';

export class AwsConnectProvider
  extends TelephonyBaseProvider
  implements ITelephonyProvider{
  [x: string]: any;
  config: AwsConnectConfig;

  sessionId: string | null = null;
  private agentId: string | null = null;
  private connectInstanceId: string | null = null;

  // Login credentials
  private username: string | null = null;
  private password: string | null = null;
  //private station: string | null = null;

  private currentAgent: any; // AWS Connect agent object
  private currentContact: any; // AWS Connect agent object
  private hadActiveCall: boolean = false;
  private contactSubscription: any;
  private wasLoggedIn: boolean = false;

  // Event callbacks
  // private onIncomingCallRingingCallbacks: ((details: CallDetails) => void)[] = [];
  // private onIncomingCallAnsweredCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutboundCallInitiatedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutboundCallAnsweredCallbacks: ((details: CallDetails) => void)[] = [];
  // private onCallTransferredCallbacks: ((details: CallDetails, targetAgentId: string) => void)[] = [];
  // private onCallEndedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onIncomingCallRejectedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutgoingCallRejectedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onAvailabilityChangedCallbacks: ((isAvailable: boolean) => void)[] = [];
  // private onLoggedInChangedCallbacks: ((isLoggedIn: boolean) => void)[] = [];
  // private onStatusChangedCallbacks: ((status: CallStatus) => void)[] = [];
  private onIncomingCallMissedCallbacks: ((details: CallDetails) => void)[] =
    [];

  constructor(
    config: AwsConnectConfig,
    connection?: HubConnection,
    wasLoggedIn?: boolean,
  ) {
    super(connection);
    this.config = config;
    this.wasLoggedIn = wasLoggedIn || false;
    // Set up axios defaults
    axios.defaults.baseURL = config.apiBaseUrl;

    this.onIncomingCallRingingCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.IncomingCallRinging),
    );

    this.onOutboundCallInitiatedCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.OutboundCallInitiated),
    );

    this.onIncomingCallAnsweredCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.CallAnswered),
    );

    this.onCallEndedCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.CallEnded),
    );

    this.onIncomingCallRejectedCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.CallRejected),
    );

    this.onOutboundCallAnsweredCallbacks.push(
      this.getSignalCallEvent(TelephonyEventType.CallAnswered),
    );
  }

  getSignalCallEvent = (eventType: TelephonyEventType) => {
    return (details: CallDetails) => {
      console.log("Sending TelephonyEvent via SignalR callDetails:", details);
      //send call ringing TelephonyEvent with signalR connection
      if (this.signalRconnection) {
        const event: TelephonyEvent = {
          eventType: eventType,
          phoneNumber: details?.callerNumber,
        };
        console.log("Sending TelephonyEvent via SignalR:", event);
        this.signalRconnection.invoke(
          "BroadcastMessageSelfAsync",
          "TelephonyEvents",
          [event],
        );
      }
    };
  };

  shouldShowLoginDialog(): boolean {
    return false;
  }
  get supportsPopout(): boolean {
    return true;
  }
  get supportsCustomViews(): boolean {
    return this.config.contactFlowId ? true : false;
  }

  // Set login credentials
  setLoginCredentials(username: string, password: string): void {
    this.username = username;
    this.password = password;

    //this.station = station;
    this.agentId = username; // Use username as agent ID
  }

  setSession(sessionId: string): void {
    this.sessionId = sessionId;
  }

  release(): void {
    super.release();
    // Disconnect SignalR connection if it exists
    this.teminateCCp();
  }

  async getExistingLogin() {
    //
    console.log("Checking if was logged in...");
    // alwasys force a Login
    console.log("this.wasLoggedIn", this.wasLoggedIn);
    if (this.wasLoggedIn) {
      await this.agentLogin();
      return true;
    }
    return false;
  }

  async agentLogin() {
    try {
      // let user = {
      //   username: Number(this.username),
      //   password: Number(this.password),
      //   station: Number(this.station),
      // };
      this.initCCP();
      this.subscribeToContacts();
      // Check if credentials are set
      // if (!this.username || !this.password || !this.station) {
      //   console.error('Login credentials not set');
      //   return false;
      // }

      // const container = document.getElementById('ccp');
      // connect.core.initCCP(container, {
      //   ccpUrl: `${this.config.instanceUrl}`,
      //   loginOptions: {
      //     autoClose: true,
      //     height: 550,
      //     width: 350,
      //   },
      //   softphone: {
      //     allowFramedSoftphone: true,
      //     allowFramedVideoCall: false,
      //     allowFramedScreenSharing: false,
      //     allowFramedScreenSharingPopUp: false,
      //   },
      // });

      this.subscribeToAgentEvents();
      this.subscribeToContactEvents();

      //return a promise that resolves when the agent is logged in
      return new Promise((resolve, reject) => {
        const doLoggin = () => {
          this.state.isLoggedIn = true;
          this.onLoggedInChangedCallbacks.forEach((cb) =>
            cb(this.state.isLoggedIn),
          );
          resolve({ result: true, session: "test234" });
        };

        const rejectLogin = (error: Error) => {
          console.error("AWS Connect login failed:", error);
          if (this.state.isLoggedIn) {
            this.state.isLoggedIn = false;
            this.onLoggedInChangedCallbacks.forEach((cb) =>
              cb(this.state.isLoggedIn),
            );
          }
          this.teminateCCp();
          reject(error);
        };

        //  connect.core.onAuthorizeSuccess(() => {

        //   console.log("!!!! authorization succeeded! onAuthorizeSuccess");
        //    doLoggin();
        // });
        connect.core.onIframeRetriesExhausted(() => {
          console.log("!!!! authorization succeeded! onIframeRetriesExhausted");
          rejectLogin(new Error("Authorization failed after retries"));
        });

        connect.core.onCTIAuthorizeRetriesExhausted(() => {
          console.log(
            "!!!! authorization succeeded! onCTIAuthorizeRetriesExhausted",
          );
          rejectLogin(
            new Error(
              "Authorization failed after onCTIAuthorizeRetriesExhausted",
            ),
          );
        });
        connect.core.onAuthorizeRetriesExhausted(() => {
          console.log(
            "!!!! authorization succeeded! onAuthorizeRetriesExhausted",
          );
          rejectLogin(
            new Error("Authorization failed after onAuthorizeRetriesExhausted"),
          );
        });

        connect.core.onInitialized(() => {
          doLoggin();
          console.log("!!!! authorization succeeded! onInitialized");
        });

        connect.core.onAuthFail(() => {
          console.log("!!!! authorization succeeded! onAuthFail");
          rejectLogin(new Error("Authorization failed after onAuthFail"));
        });

        //set logged in
      });
    } catch (error) {
      this.teminateCCp();
      return Promise.reject(error);
    }
  }
  private getContactDirection(contact: any): CallDirection {
    const type = contact.getType();
    console.log("Contact type:", type);

    if (type === connect.ContactType.QUEUE_CALLBACK) {
      return CallDirection.Inbound;
    }

    return contact.isInbound() ? CallDirection.Inbound : CallDirection.Outbound;
  }
  subscribeToAgentEvents() {
    connect.agent((agent) => {
      this.currentAgent = agent;
      //eventBus.emit('AgentInitialized');
      agent.onRefresh((agent) => this.handleAgentRefresh(agent));
      // agent.onMuteToggle((isAgentMutedStatus) => {
      //   this.handleAgentMuteToggle(isAgentMutedStatus);
      // });

      agent.onStateChange((agentStateChange) => {
        const newState = agentStateChange.newState;
        const isAvailable = newState === "Available";
        const wasAvailable = this.state.isAvailable;

        console.log("Agent availability state changed to:", newState);
        if (wasAvailable !== isAvailable) {
          this.state.isAvailable = isAvailable;
          this.onAvailabilityChangedCallbacks.forEach((cb) => cb(isAvailable));
        }
      });
    });
  }

  subscribeToContactEvents() {
    connect.contact((contact) => {
      this.currentContact = contact;
      console.log("New contact received:", contact);

      contact.onIncoming((incomingContact) => {
        console.log(" Incoming contact:", incomingContact);

        this.state.currentCallDirection =
          this.getContactDirection(incomingContact);
        console.log(
          "Call direction (onIncoming):",
          this.state.currentCallDirection,
        );

        this.handleContactConnecting(incomingContact);
      });

      contact.onConnecting((connectingContact) => {
        console.log(" Connecting contact:", connectingContact);

        this.state.currentCallDirection =
          this.getContactDirection(connectingContact);
        console.log(
          "Call direction (onConnecting):",
          this.state.currentCallDirection,
        );

        this.handleContactConnecting(connectingContact);
      });

      contact.onConnected(
        async (connectedContact) =>
          await this.handleContactConnected(connectedContact),
      );

      contact.onEnded(
        async (endedContact) => await this.handleContactEnded(endedContact),
      );
      contact.onMissed((missedContact) =>
        this.handleContactMissed(missedContact),
      );

      // contact.onDestroy((destroyedContact) =>
      //   this.handleContactDestroy(destroyedContact)
      // );
    });
  }

  handleAgentRefresh(agent: any) {
    const status = agent.getStatus().name;
    console.log("Agent status refreshed:", status);

    const wasAvailable = this.state.isAvailable;
    this.state.isAvailable = status === "Available";

    // Trigger availability changed callback
    if (wasAvailable !== this.state.isAvailable) {
      this.onAvailabilityChangedCallbacks.forEach((cb) =>
        cb(this.state.isAvailable),
      );
    }
  }

  handleContactConnecting(contact: any) {
    this.hadActiveCall = false;
    const cid = contact.getContactId?.();

    // For queue callbacks, ensure direction is always Inbound regardless of agent state
    const contactType = contact.getType();
    const isQueueCallback = contactType === connect.ContactType.QUEUE_CALLBACK;

    // For non-queue callbacks, prevent duplicate processing
    // For queue callbacks, allow processing on every ring so popup shows even when agent is pending
    if (cid && !isQueueCallback) {
      this.handledConnectingContactIds ??= new Set<string>();
      if (this.handledConnectingContactIds.has(cid)) {
        return;
      }
      this.handledConnectingContactIds.add(cid);
    }

    const callDirection = isQueueCallback
      ? CallDirection.Inbound
      : this.state.currentCallDirection;

    const initialConnection = contact.getInitialConnection?.();
    const endpoint =
      initialConnection?.getEndpoint?.() ?? contact.getCustomerEndpoint?.();
    const customerPhoneNumber = endpoint?.phoneNumber;
    if (!customerPhoneNumber) {
      console.warn(
        "No customer phone number on contact; skipping connect init",
      );
      return;
    }
    const normalized = this.normalizePhoneForDial(
      customerPhoneNumber,
      this.config?.defaultCountryCode,
    );

    let callId = contact.getContactId?.() ?? "unknown";
    //add the date
    callId = `${callId}_${new Date().toISOString()}`;

    this.state.status = CallStatus.Ringing;
    this.state.callerNumber = normalized.cleaned;
    this.state.callerName = "Unknown";
    this.state.currentCallId = callId;
    this.state.currentCallDirection = callDirection;

    this.currentCall = this.createCallDetails(
      normalized,
      callDirection,
      callId,
    );
    this.currentCall.callerName = "Unknown";
    this.currentCall.startTime = new Date(); // Track call start time
    this.currentCall.recordingId = callId;

    if (callDirection === CallDirection.Inbound) {
      this.onIncomingCallRingingCallbacks.forEach((cb) =>
        cb(this.currentCall!),
      );
    } else {
      this.onOutboundCallInitiatedCallbacks.forEach((cb) =>
        cb(this.currentCall!),
      );
    }

    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status!));
  }

  async handleContactConnected(contact: any) {
    let contactFlowId = this.config.contactFlowId || undefined;
    console.log("Contact connected:", contact);

    // existing state updates
    this.state.status = CallStatus.InCall;
    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status!));
    this.hadActiveCall = true;

    const answeredCallbacks =
      this.state.currentCallDirection === CallDirection.Inbound
        ? this.onIncomingCallAnsweredCallbacks
        : this.onOutboundCallAnsweredCallbacks;
    answeredCallbacks.forEach((cb) => cb(this.currentCall!));

    //if no contact flow set dont setup flow
    if (!contactFlowId) return;

    try {
      const connectUrl =
        this.config.instanceUrl ||
        "https://pd-contactcentre.my.connect.aws/connect";

      // Check if the Amazon Connect Streams agentApp module and its initApp function are available
      // before attempting to initialize a custom view for the current contact.
      // This prevents errors if the agentApp integration is not loaded or supported in the current environment.

      // Wait for customviews container to exist in DOM before initializing
      const waitForContainer = async (maxAttempts = 10, delayMs = 100) => {
        for (let i = 0; i < maxAttempts; i++) {
          const container = document.getElementById("customviews");
          if (container) {
            return container;
          }

          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
        console.error(
          `ERROR: customviews container NOT FOUND after ${maxAttempts * delayMs}ms!`,
        );
        return null;
      };

      if (
        window.connect &&
        window.connect.agentApp &&
        typeof window.connect.agentApp.initApp === "function"
      ) {
        const container = await waitForContainer();

        if (!container) {
          console.error(
            "Cannot initialize custom view - container not available",
          );
          return;
        }

        console.log(
          "Initializing custom view for contact:",
          contact.getContactId(),
        );

        connect.agentApp.initApp(
          "customviews",
          "customviews",
          connectUrl + "/stargate/app",
          {
            style: "width:200%; height:600px;",
            customViewsParams: {
              contact: contact,
              contactFlowId,
              iframeSuffix: contactFlowId
                ? `${contact.getContactId()}-${contactFlowId}`
                : `${contact.getContactId()}`,
              disableAutoDestroy: false,
              terminateCustomViewOptions: {
                hideIframe: true,
                timeout: 5000,
                resolveIframe: true,
              },
            },
          },
        );

        // Check again after initApp
        setTimeout(() => {
          const containerAfter = document.getElementById("customviews");
          if (containerAfter) {
            const iframes = containerAfter.querySelectorAll("iframe");
            console.log(
              "Iframes found in customviews after initApp:",
              iframes.length,
            );
          }
        }, 100);
      } else {
        console.warn("connect.agentApp.initApp() is not available yet");
      }
    } catch (err) {
      console.error("Failed to initialize custom view:", err);
    }
  }

  async handleContactEnded(contact: any) {
    console.log("Contact ended:", contact);
    console.log("Contact state:", contact.getState());

    if (this.currentCall) {
      // Set end time before firing event
      if (!this.currentCall.endTime) {
        this.currentCall.endTime = new Date();
      }

      // Fire event - base provider will handle persistence
      this.onCallEndedCallbacks.forEach((cb) => cb(this.currentCall));
    }

    const contactState = contact.getState();

    // If AWS doesn't go into ACW, manually switch to Awaiting so Finalise shows
    if (this.hadActiveCall) {
      if (contactState.type !== "acw") {
        console.log(
          "No ACW detected, setting status to Awaiting for Finalise button",
        );
        this.state.status = CallStatus.Awaiting;
        this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status!));
      } else {
        console.log(
          "ACW state detected, letting handleContactACW manage status",
        );
      }
      // do NOT reset immediately; ACW flow will clear when finalised
    } else {
      // Call was never connected (no-answer / hung up before connect) -> go idle, no Finalise
      this.resetCallState();
    }
  }

  handleContactMissed(missedContact: any) {
    console.log("Contact missed:", missedContact);

    const missedCall = this.currentCall;

    missedContact.clear({
      success: () => {
        console.log("Missed contact cleared successfully");
      },
      failure: (err: any) => {
        console.error("Failed to clear missed contact:", err);
      },
    });

    this.resetCallState();

    if (missedCall) {
      this.onIncomingCallMissedCallbacks.forEach((cb) => cb(missedCall));
    }
  }

  //Aws softphone mute/unmute
  muteCall = async () => {
    if (this.currentAgent) {
      try {
        await this.currentAgent.mute();
        console.log("Muted successfully");
      } catch (err) {
        console.error("Mute failed", err);
      }
    } else {
      console.warn("currentAgent not available for mute");
    }
  };

  unmuteCall = async () => {
    if (this.currentAgent) {
      try {
        await this.currentAgent.unmute();
        console.log("Unmuted successfully");
      } catch (err) {
        console.error("Unmute failed", err);
      }
    } else {
      console.warn("currentAgent not available for unmute");
    }
  };
  //aws hold call
  holdCall = async () => {
    const contact = this.getActiveContact();
    if (contact) {
      const agentConnection = contact.getActiveInitialConnection();
      if (agentConnection) {
        return agentConnection.hold();
      }
    }
  };
  private getActiveContact(): any {
    return this.currentContact;
  }

  unholdCall = async () => {
    const contact = this.getActiveContact();
    if (contact) {
      const agentConnection = contact.getActiveInitialConnection();
      if (agentConnection) {
        return agentConnection.resume();
      }
    }
  };

  initCCP() {
    const connectUrl =
      this.config.instanceUrl ||
      "https://pd-contactcentre.my.connect.aws/connect";
    const ccpContainer = document.getElementById("ccp");

    if (!ccpContainer) {
      console.warn("CCP container not found");
      return false;
    }

    // Log how many iframes exist
    console.log(
      "CCP container iframe count:",
      ccpContainer.querySelectorAll("iframe").length,
    );

    if (ccpContainer.querySelector("iframe")) {
      console.log("CCP iframe already initialized");
      return true;
    }

    try {
      window.connect.core.initCCP(ccpContainer, {
        ccpUrl: connectUrl + "/ccp-v2/",
        loginPopup: true,
        loginPopupAutoClose: true,
        loginOptions: {
          // optional, if provided opens login in new window
          autoClose: true, // optional, defaults to `false`
          height: 600, // optional, defaults to 578
          width: 400, // optional, defaults to 433
          top: 0, // optional, defaults to 0
          left: 0, // optional, defaults to 0
        },
        region: this.config.region || "af-south-1",
        softphone: { allowFramedSoftphone: true },
      });
      console.log("CCP initialized");

      // connect.agentApp.initApp("ccp", "ccp", connectUrl + "/ccp-v2/", {
      //   style: "width:400px; height:600px;",
      // });
      return true;
    } catch (err) {
      console.error("Error initializing CCP:", err);
      return false;
    }
  }

  subscribeToContacts() {
    try {
      this.contactSubscription = window.connect.contact(
        this.handleContact.bind(this),
      );
      console.log("Subscribed to contacts");
    } catch (error) {
      console.error("Error subscribing to contacts:", error);
    }
  }

  handleContact(contact: any) {
    console.log("Contact received:", contact);

    contact.onConnected(() => {
      console.log("Contact connected");
      // You can emit events or update state here as needed
      // For example, call a callback or update an observable
      // If you want to support custom views, you can add that logic here as well
    });
  }

  // Optionally, add a method to clean up
  unsubscribeFromContacts() {
    if (this.contactSubscription?.unsubscribe) {
      this.contactSubscription.unsubscribe();
      console.log("Unsubscribed from contacts");
    }
  }
  // Get headers with session ID
  private getAuthHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: this.sessionId ? `Bearer ${this.sessionId}` : undefined,
      "X-Session-Id": this.sessionId || undefined,
    };
  }

  private resetCallState(): void {
    this.state.status = CallStatus.Idle;
    this.state.callerNumber = undefined;
    this.state.callerName = undefined;
    this.state.currentCallId = undefined;
    this.currentCall = null;
    this.hadActiveCall = false;
    //todo: call correct call back
    this.onIncomingCallRejectedCallbacks.forEach((cb) => cb(this.currentCall!));
    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status!));
  }

  // ITelephonyProvider implementation
  async login(): Promise<boolean> {
    try {
      if (!this.username || !this.password) {
        console.error("AWS Connect login credentials not set");
        return false;
      }

      // Step 1: Login to backend API to get sessionId
      console.log("Logging in to AWS Connect backend API...");
      const loginResponse: AxiosResponse<AwsConnectLoginResponse> =
        await axios.post("/api/awsconnect/login", {
          username: this.username,
          password: this.password,
          instanceId: this.config.instanceId,
        });

      if (!loginResponse.data.success || !loginResponse.data.sessionId) {
        console.error(
          "AWS Connect backend login failed:",
          loginResponse.data.message,
        );
        return false;
      }

      this.sessionId = loginResponse.data.sessionId;
      this.connectInstanceId = loginResponse.data.connectInstanceId;
      console.log(
        "AWS Connect backend login successful, sessionId:",
        this.sessionId,
      );

      // Step 2: Start SignalR connection with sessionId
      console.log("Starting SignalR connection for AWS Connect...");

      // Step 4: Start AWS Connect session
      console.log("Starting AWS Connect session...");
      const sessionResponse: AxiosResponse<AwsConnectStartSessionResponse> =
        await axios.post(
          "/api/awsconnect/start-session",
          {
            agentId: this.agentId,
            instanceId: this.connectInstanceId,
          },
          { headers: this.getAuthHeaders() },
        );

      if (!sessionResponse.data.success) {
        console.error(
          "AWS Connect start session failed:",
          sessionResponse.data.message,
        );
        await this.cleanup();
        return false;
      }

      // Update state based on session response
      this.state.isLoggedIn = true;
      this.state.isAvailable = sessionResponse.data.isAvailable || false;

      console.log("AWS Connect session started successfully");
      console.log("Agent online:", sessionResponse.data.isOnline);
      console.log("Agent available:", sessionResponse.data.isAvailable);

      return true;
    } catch (error) {
      console.error("AWS Connect login error:", error);
      await this.cleanup();
      return false;
    }
  }

  teminateCCp(): void {
    try {
      if (
        window.connect &&
        window.connect.core &&
        window.connect.core.terminate
      ) {
        window.connect.core.terminate();
      }
    } catch (e) {
      console.warn("Error terminating CCP:", e);
    }
    const containerDiv = document.getElementById("ccp");
    if (containerDiv) {
      // Remove all iframes in the container
      const iframes = containerDiv.querySelectorAll("iframe");
      iframes.forEach((iframe) => containerDiv.removeChild(iframe));
    }
  }

  async logout(): Promise<boolean> {
    try {
      console.log("Logging out from AWS Connect...");

      this.teminateCCp();

      // Step 2: Cleanup local state

      await this.cleanup();

      console.log("AWS Connect logout completed");
      this.onLoggedInChangedCallbacks.forEach((cb) =>
        cb(this.state.isLoggedIn),
      );
      return true;
    } catch (error) {
      console.error("AWS Connect logout error:", error);
      await this.cleanup();
      return false;
    }
  }

  private async cleanup(): Promise<void> {
    // Stop SignalR connection
    console.log("Runnning Cleanup...");
    //await stopSignalR();

    // Reset state
    this.state.isLoggedIn = false;
    this.state.isAvailable = false;
    this.state.status = CallStatus.Idle;
    this.currentCall = null;
    this.sessionId = null;
    this.connectInstanceId = null;
  }

  async setOnBreak(): Promise<void> {
    await this.setOnBreakWithReason(20); // Default break reason
  }

  async setOnBreakWithReason(reasonCode: number): Promise<void> {
    const BREAK_REASON_MAP: Record<number, string> = {
      10: "Nature Calls", // Bathroom
      20: "Lunch", // Break
      30: "Lunch", // Meeting
      40: "Lunch", // Lunch
      50: "Offline", // End Shift
    };

    const breakReasonName = BREAK_REASON_MAP[reasonCode] ?? "Offline";
    const allStates = this.currentAgent.getAgentStates();

    const targetState = allStates.find(
      (s: any) => s.name.toLowerCase() === breakReasonName.toLowerCase(),
    );

    if (!targetState) {
      console.warn(
        `No matching AWS agent state found for reason: ${breakReasonName}`,
      );
      return;
    }

    await new Promise<void>((resolve, reject) => {
      this.currentAgent.setState(
        targetState,
        {
          success: () => {
            console.log(`Agent state set to: ${targetState.name}`);
            this.state.isAvailable = false;
            this.onAvailabilityChangedCallbacks.forEach((cb) => cb(false));
            resolve();
          },
          failure: (err: any) => {
            console.error("Failed to set agent state:", err);
            reject(err);
          },
        },
        { enqueueNextState: false },
      );
    });
  }

  async setAvailable(): Promise<void> {
    var state = this.currentAgent.getAgentStates()[0];
    console.log("Setting AWS Connect agent state to available:", state);
    await new Promise<void>((resolve, reject) => {
      this.currentAgent.setState(
        state,
        {
          success: function () {
            resolve();
          },
          failure: function (err: any) {
            reject(err);
          },
        },
        { enqueueNextState: false },
      );
    });
  }

  // End shift method
  async endShift(): Promise<boolean> {
    const allStates = this.currentAgent.getAgentStates();
    console.log("All available agent states:", allStates);

    const breakState = allStates.find(
      (s: any) =>
        s.name.toLowerCase().includes("break") ||
        s.name.toLowerCase().includes("offline"),
    );

    if (!breakState) {
      console.warn("No break state found");
      return false;
    }

    console.log("Setting agent state to:", breakState.name);

    await new Promise<void>((resolve, reject) => {
      this.currentAgent.setState(
        breakState,
        {
          success: () => {
            const currentState = this.currentAgent.getState();
            console.log("Agent is now in state:", currentState.name);
            this.state.isAvailable = false;
            this.onAvailabilityChangedCallbacks.forEach((cb) => cb(false));
            resolve();
          },
          failure: (err: any) => {
            console.error("Failed to set break state:", err);
            reject(err);
          },
        },
        { enqueueNextState: false },
      );
    });

    return true;
  }

  async dial(phoneNumber: string): Promise<void> {
    try {
      const normalizedNumber = this.normalizePhoneForDial(
        phoneNumber,
        this.config?.defaultCountryCode,
      );
      console.log("Dialing with AWS Connect:", normalizedNumber);

      const endpoint = connect.Endpoint.byPhoneNumber(normalizedNumber.cleaned);
      await this.executeContactActionWithArgs(
        endpoint,
        this.currentAgent.connect.bind(this.currentAgent),
      );
    } catch (error) {
      console.error("Error dialing with AWS Connect:", error);
    }
  }

  async answerCall(): Promise<void> {
    await this.executeContactAction(
      this.currentContact.accept.bind(this.currentContact),
    );
    // this.state.status = CallStatus.InCall;
    // this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status!));
  }

  private async executeContactActionWithArgs(
    args: any,
    actionFn: Function,
  ): Promise<void> {
    await new Promise<void>((resolve, reject) => {
      actionFn(args, {
        success: () => resolve(),
        failure: (err: any) => reject(err),
      });
    });
  }

  private async executeContactAction(actionFn: Function): Promise<void> {
    await new Promise<void>((resolve, reject) => {
      actionFn({
        success: () => resolve(),
        failure: (err: any) => reject(err),
      });
    });
  }

  async rejectCall(): Promise<void> {
    console.log("Rejecting call:", this.currentContact);
    await this.executeContactAction(
      this.currentContact.reject.bind(this.currentContact),
    );
    this.resetCallState();
  }

  async finaliseCall(): Promise<void> {
    console.log("Finalising call:", this.currentContact);

    if (this.currentContact) {
      // Clear the contact to complete ACW, then reset local state
      await new Promise<void>((resolve) => {
        this.currentContact.clear({
          success: () => {
            console.log("Contact cleared successfully - ACW completed");
            resolve();
          },
          failure: (err: any) => {
            console.error("Failed to clear contact:", err);
            resolve(); // continue to reset state below
          },
        });
      });
      this.resetCallState();
    } else {
      console.warn("No current contact to finalize");
      this.resetCallState();
    }
  }

  async endCall(): Promise<void> {
    console.log("Ending call:", this.currentContact);

    const agentConnection = this.currentContact.getAgentConnection();
    if (agentConnection && agentConnection.destroy) {
      // Set end time before firing event
      if (this.currentCall && !this.currentCall.endTime) {
        this.currentCall.endTime = new Date();
      }

      // Fire event before destroy
      if (this.currentCall) {
        this.onCallEndedCallbacks.forEach((cb) => cb(this.currentCall!));
      }

      await this.executeContactAction(
        agentConnection.destroy.bind(agentConnection),
      );
    }
  }

  async transferCall(phoneNumber: string, isAgent: boolean): Promise<void> {
    // phoneNumber is now a phone number. Use agentConnection.addConnection for transfer, then destroy agent's call
    console.log("transfer to phoneNumber:", phoneNumber);
    console.log("transfer to isAgent:", isAgent);
    try {
      const contact = this.currentContact;
      if (!contact) {
        console.warn("No active contact to transfer");
        return;
      }

      // Normalize phone number for dial
      const normalized = this.normalizePhoneForDial(
        phoneNumber,
        this.config?.defaultCountryCode,
      );
      const endpoint = window.connect.Endpoint.byPhoneNumber(
        normalized.cleaned,
      );

      // Get the agent connection
      const agentConnection = contact.getAgentConnection();
      if (!agentConnection) {
        console.warn("No agent connection found for current contact");
        return;
      }

      // Step 1: Add the new connection (transfer target)
      await new Promise<void>((resolve, reject) => {
        contact.addConnection(endpoint, {
          success: () => {
            console.log("Successfully added connection to transfer target");
            resolve();
          },
          failure: (err: any) => {
            console.error("Failed to add connection to transfer target:", err);
            reject(err);
          },
        });
      });

      //delay the destroy to ensure transfer completes
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Step 2: Destroy the agent's connection (drop agent from call)
      await new Promise<void>((resolve, reject) => {
        agentConnection.destroy({
          success: () => {
            console.log("Agent connection destroyed after transfer");
            resolve();
          },
          failure: (err: any) => {
            console.error(
              "Failed to destroy agent connection after transfer:",
              err,
            );
            reject(err);
          },
        });
      });
    } catch (error) {
      console.error("Error performing cold transfer:", error);
    }
  }

  // getCallDetails(callId?: string): CallDetails | null {
  //   if (!callId && this.currentCall) {
  //     return this.currentCall;
  //   }

  //   if (callId && this.currentCall && this.currentCall.id === callId) {
  //     return this.currentCall;
  //   }

  //   return null;
  // }

  // async getRecordingUrl(callId: string): Promise<string | null> {
  //   try {
  //     if (!this.sessionId) {
  //       return null;
  //     }

  //     const response = await axios.get(`/api/awsconnect/recording/${callId}`, { headers: this.getAuthHeaders() });

  //     return response.data.recordingUrl || null;
  //   } catch (error) {
  //     console.error('Error getting AWS Connect recording URL:', error);
  //     return null;
  //   }
  // }

  // getState(): TelephonyProviderState {
  //   return { ...this.state };
  // }

  // // Event registration methods
  // onIncomingCallRinging(callback: (details: CallDetails) => void): void {
  //   this.onIncomingCallRingingCallbacks.push(callback);
  // }

  // onIncomingCallAnswered(callback: (details: CallDetails) => void): void {
  //   this.onIncomingCallAnsweredCallbacks.push(callback);
  // }

  // onOutboundCallInitiated(callback: (details: CallDetails) => void): void {
  //   this.onOutboundCallInitiatedCallbacks.push(callback);
  // }

  // onOutboundCallAnswered(callback: (details: CallDetails) => void): void {
  //   this.onOutboundCallAnsweredCallbacks.push(callback);
  // }

  // onCallTransferred(callback: (details: CallDetails, targetAgentId: string) => void): void {
  //   this.onCallTransferredCallbacks.push(callback);
  // }

  // onCallEnded(callback: (details: CallDetails) => void): void {
  //   this.onCallEndedCallbacks.push(callback);
  // }

  // onIncomingCallRejected(callback: (details: CallDetails) => void): void {
  //   this.onIncomingCallRejectedCallbacks.push(callback);
  // }

  // onOutgoingCallRejected(callback: (details: CallDetails) => void): void {
  //   this.onOutgoingCallRejectedCallbacks.push(callback);
  // }

  // onAvailabilityChanged(callback: (isAvailable: boolean) => void): void {
  //   this.onAvailabilityChangedCallbacks.push(callback);
  // }

  // onLoggedInChanged(callback: (isLoggedIn: boolean) => void): void {
  //   this.onLoggedInChangedCallbacks.push(callback);
  // }

  // onStatusChanged(callback: (status: CallStatus) => void): void {
  //   this.onStatusChangedCallbacks.push(callback);
  // }
}
